<template>
  <div>
    <table-header
      :filters="filteringOptions"
      :title="'Wypłaty'"
      :withPagination="true"
      :withFilters="true"
      :dispatchAction="'fetchAllPayouts'"
      :onPage="this.payouts.on_page"
      :pageNumber="this.payouts.page_number"
      :total="this.payouts.total"
      :refreshAction="true"
      :tableName="'payouts'"
      :checkbox="true"
      @firstMethodToListen="selectAll(!allSelected)"
      @secondMethodToListen="generateCSV()"
      :confirmActionMessage="'Czy napewno chcesz zaakceptować wybrane wypłaty?'"
      :checkAction="true"
      :dates="true"
    ></table-header>

    <table
      class="table table-striped table-sm"
      v-if="
        this.payouts && this.payouts.payouts && this.payouts.payouts.length > 0
      "
    >
      <thead>
        <tr class="tr-table">
          <th scope="col">ID wypłaty</th>
          <th scope="col">Data</th>
          <th scope="col">Imię</th>
          <th scope="col">Nazwisko</th>
          <th scope="col">Numer telefonu</th>
          <th scope="col">Rola</th>
          <th scope="col">Wartość</th>
          <th scope="col">Status</th>
          <th scope="col">Data ostatniej akcji</th>
          <th scope="col">Akcja</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="withdraw in payouts.payouts" :key="withdraw.id">
          <td>
            <label :for="withdraw.id" class="checkboxPayout">
              <input
                type="checkbox"
                :id="withdraw.id"
                :value="withdraw.id"
                v-model="checkedPayouts"
                class="checkboxPayout"
              />
              <div>
                {{ withdraw.id }}
              </div>
            </label>
          </td>
          <td>
            <div>
              {{
                withdraw.creationDate
                  ? formattedDate(withdraw.creationDate)
                  : ""
              }}
            </div>
          </td>
          <td>
            {{ withdraw.user.first_name ? withdraw.user.first_name : "" }}
          </td>
          <td>
            {{ withdraw.user.last_name ? withdraw.user.last_name : "" }}
          </td>
          <td>{{ withdraw.user.phone ? withdraw.user.phone : "" }}</td>
          <td>{{ withdraw.user.role ? withdraw.user.role : "" }}</td>
          <td>
            {{ withdraw.amount_to_withdraw ? withdraw.amount_to_withdraw : "" }}
          </td>
          <td v-if="withdraw.status === 'WAITING'">Oczekuje na akceptacje</td>
          <td v-if="withdraw.status === 'ACCEPTED'">Zaakceptowano</td>
          <td v-if="withdraw.status === 'REJECTED'">Odrzucono</td>
          <td v-if="withdraw && withdraw.date_of_status_change">
            {{ formattedDate(withdraw.date_of_status_change) }}
          </td>
          <td v-else>Brak</td>
          <td>
            <div
              class="account-not-verified"
              v-if="
                !withdraw.isAccountNumberVerified &&
                  withdraw.status === 'WAITING'
              "
            >
              Konto bankowe niezweryfikowane
            </div>
            <span class="decisionIcons" v-if="withdraw.status === 'WAITING'">
              <i
                @click="handlePayoutDecision(withdraw, 'accept')"
                class="fas fa-check-circle acceptIcon"
              ></i>
              <i
                @click="handlePayoutDecision(withdraw, 'reject')"
                class="far fa-times-circle rejectIcon"
              ></i>
            </span>
            <div
              v-if="withdraw.status === 'REJECTED'"
              style="text-align: center"
            >
              Płatność została odrzucona
            </div>
            <div
              v-if="withdraw.status === 'ACCEPTED'"
              style="text-align: center"
            >
              Płatność została zaakceptowana
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import shared from "../shared";
import axios from "../axios";
import TableHeader from "../components/TableHeader.vue";

export default {
  name: "Payouts",
  components: { TableHeader },
  computed: {
    payouts() {
      return this.$store.getters.getAllPayouts;
    },
  },
  created() {
    this.$store.dispatch("fetchAllPayouts", {
      on_page: 20,
      page_number: 1,
      status: this.status,
    });
    this.formattedDate = shared.formattedDate;
    this.startOfDay = shared.startOfDayFromTimestampDate;
    this.endOfDay = shared.endOfDayFromTimestampDate;
  },

  methods: {
    clearDate(date) {
      if (date === "from") {
        this.date_from = null;
        this.$store.dispatch("fetchAllPayouts", {
          on_page: this.payouts.on_page,
          page_number: this.payouts.page_number,
          filter: this.filter_param,
          status: this.status,
        });
      }
      if (date === "to") {
        this.date_to = null;
        this.$store.dispatch("fetchAllPayouts", {
          on_page: this.payouts.on_page,
          page_number: this.payouts.page_number,
          filter: this.filter_param,
          status: this.status,
        });
      }
    },
    selectAll(selectAll) {
      if (selectAll) {
        this.payouts.payouts.forEach((element) => {
          this.checkedPayouts.push(element.id);
        });
      } else {
        this.checkedPayouts = [];
      }
      this.allSelected = !this.allSelected;
    },

    async generateCSV() {
      axios
        .post(`api/withdraw/exportToCsv`, {
          ids: this.checkedPayouts,
        })
        .then((response) => {
          let fileName = "";
          for (const [key, value] of Object.entries(response.headers)) {
            if (key === "content-disposition") {
              const res = value.split('"');
              fileName = res[1];
              fileName = unescape(fileName);
            }
          }
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          this.checkedPayouts = [];
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            group: "error",
            text: "Nie udało się pobrać pliku z wypłatami",
          });
        });

      await axios
        .post(`api/withdraw/waiting/accept`, {
          ids: this.checkedPayouts,
        })
        .then(() => {
          this.$notify({
            group: "success",
            text:
              "Pomyślnie zaakceptowano wszystkie oczekujące wypłaty oraz pobrano plik",
          });
        })
        .catch((err) => {
          console.log(err);
          this.$notify({
            group: "error",
            text: "Nie udało się zaakceptować wypłat",
          });
        });
    },

    async changeStatus(withdraw, decision) {
      try {
        await axios.post(`api/withdraw/${withdraw.id}/${decision}`);
        await this.$store.dispatch("fetchAllPayouts", {
          on_page: this.payouts.on_page,
          page_number: this.payouts.page_number,
          filter: this.filter_param,
          status: this.status,
        });
        if (decision === "accept") {
          this.$notify({
            group: "success",
            text: "Pomyślnie zatwierdzono wypłatę",
          });
        } else {
          this.$notify({
            group: "success",
            text: "Pomyślnie odrzucono wypłatę",
          });
          this.$store.dispatch("fetchAllPayouts", {
            on_page: 20,
            page_number: 1,
            status: this.status,
          });
        }
      } catch (error) {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error ===
            "user_do_not_have_enough_money_in_wallet"
        ) {
          this.$notify({
            group: "error",
            text: "Brak wystarczających środków do wypłaty.",
          });
        } else {
          console.log(error.response.data.error);
        }
      } finally {
        this.payoutInProgress = false;
      }
    },

    async handlePayoutDecision(withdraw, decision) {
      if (!this.payoutInProgress) {
        this.payoutInProgress = true;
        if (withdraw.status !== "ACCEPTED" && decision === "accept") {
          await this.changeStatus(withdraw, decision);
        }
        if (withdraw.status !== "REJECTED" && decision === "reject") {
          await this.changeStatus(withdraw, decision);
        }
      }
    },
  },
  data() {
    return {
      status: "ACCEPTED",
      filter_param: "",
      checkedPayouts: [],
      allSelected: false,
      date_from: "",
      date_to: "",
      filteringOptions: [
        {
          name: "",
          displayName: "Wszystkie",
        },
        {
          name: "WAITING",
          displayName: "Oczekujące",
        },
        {
          name: "ACCEPTED",
          displayName: "Zaakceptowane",
        },
        {
          name: "REJECTED",
          displayName: "Odrzucone",
        },
      ],
      payoutInProgress: false,
    };
  },
};
</script>

<style>
.decisionIcons {
  display: flex;
  justify-content: center;
}
.decisionIcons i {
  margin: 0 10px 0 10px;
  font-size: 20px;
}
.acceptIcon {
  color: rgb(3, 122, 3);
}
.acceptIcon:hover {
  color: rgb(9, 219, 9);
}
.rejectIcon {
  color: tomato;
}
.rejectIcon:hover {
  color: red;
}
.account-not-verified {
  color: red;
  font-weight: 500;
  margin-bottom: 1rem;
  text-align: center;
}
</style>
